<template>
<div class="chapter">
<div class="inner_page">
<div class="chap" id="epigraph">
<p class="ct"><a class="xref" href="#/OEBPS/pppjusticedamned0006#toc">Epigraph</a></p>
<div class="epigraph">
<p class="ep">Whether it makes one cry or sing,<br class="calibre1"/>justice must be carried out.</p>
<p class="ept">—Marie de France, c. 1170, “Lanval,”<br class="calibre1"/>l. 437-8 (translator unknown)</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ppp-justicedamned0004.vue?1193a400